import axios from 'axios';
import {
  buildSerializer,
  buildJSONAPIDeserializerInterceptor,
  JSONAPIAdapter,
} from '@unite-us/json-api-resources';

const serializer = buildSerializer();

const jsonApiResponseInterceptor = buildJSONAPIDeserializerInterceptor(serializer);

const apiV1Client = axios.create();

const inheritHostDefaults = (config) => {
  // eslint-disable-next-line no-param-reassign
  config.baseURL = axios.defaults.baseURL;
  const auth = axios.defaults.headers.Authorization ??
    axios.defaults.headers.common?.Authorization;
  if (auth) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = auth;
  }
  // eslint-disable-next-line no-param-reassign
  config.headers['X-Application-Source'] = 'web';
  return config;
};

apiV1Client.interceptors.request.use(inheritHostDefaults);
apiV1Client.interceptors.response.use(jsonApiResponseInterceptor);

const apiV1 = new JSONAPIAdapter(apiV1Client, serializer);

const apis = { apiV1 };

export const DEFAULT_API = 'apiV1';

export const getAdapter = (api = DEFAULT_API) => apis[api];
